<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useMobile } from '@/composables/useMobile';
import ProfileDrawer from './ProfileDrawer.vue';

const { isMobile } = useMobile();
const route = useRoute();

const isProfileDrawerOpen = ref(false);

const openProfileDrawer = () => {
  isProfileDrawerOpen.value = true;
};

// Get page title from route meta or name
const getPageTitle = () => {
  return route.meta?.title || route.name || 'Dashboard';
};
</script>

<template>
  <div v-if="isMobile">
    <!-- Mobile Top Bar -->
    <div
      :class="[
        'fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-theme-1 to-theme-2 text-white shadow-lg',
        'flex items-center justify-between px-4',
        'mobile-top-bar',
      ]"
    >
      <!-- Left side - Logo and title -->
      <div class="flex items-center space-x-3 flex-1 min-w-0">
        <img src="/src/assets/images/logo/logo-white.png" alt="Casim Logo" class="w-8 h-8 flex-shrink-0" />
        <div class="min-w-0 flex-1">
          <h1 class="text-lg font-semibold truncate">
            {{ getPageTitle() }}
          </h1>
        </div>
      </div>

      <!-- Right side - Actions -->
      <div class="flex items-center space-x-2">
        <!-- Profile -->
        <button
          @click="openProfileDrawer"
          class="p-1 rounded-full hover:bg-white/10 active:scale-95 transition-all mobile-touch-target"
          aria-label="Profile"
        >
          <div class="w-8 h-8 rounded-full overflow-hidden border-2 border-white/20">
            <img src="/src/assets/images/users/user8-50x50.jpg" alt="Profile" class="w-full h-full object-cover" />
          </div>
        </button>
      </div>
    </div>

    <!-- Profile Drawer -->
    <ProfileDrawer :is-open="isProfileDrawerOpen" @update:is-open="isProfileDrawerOpen = $event" />
  </div>
</template>

<style scoped>
/* Remove local styles - using global mobile.css styles instead */
</style>
